/* eslint-disable react/prop-types */
import React from 'react'
import propTypes from 'prop-types'
import styled from 'styled-components'

const ContainerStyled = styled.div`
  width: 65%;
  padding: ${props => props.$page ? '15px' : ' 0px 15px'};
  margin: auto;
  box-sizing: border-box;
  @media screen and (max-width:1300px) {
    width: 70%;
  }
  @media screen and (max-width:1200px) {
    width: 90%;
  }
  @media screen and (max-width:900px) {
    width: 95%;
  }
  @media screen and (max-width:700px) {
    width: 96%;
  }
  @media screen and (max-width:600px) {
    width: 100%;
  }
`

const Container = props => {
  return (
    <ContainerStyled $page={props.page} id={props.id}>
      {props.children}
    </ContainerStyled>
  )
}

Container.propTypes = {
  page: propTypes.bool,
  children: propTypes.any
}

export default Container
